import React, {
    useRef,
    useState
} from "react";

import "./Relationnel.css";
import "./Relationnel.mobile.css";


const Relationnel = () => {

    const contentData = {

        titleLine1:
            "L'ENGAGEMENT",

        titleLine2:
            "RELATIONNEL & HUMAIN",

        introText:
            "La réussite technique ne peut être dissociée de la qualité des échanges. Je suis un partenaire proactif, intégrant vos écosystèmes humains avec la même rigueur que vos infrastructures logicielles.",

        footerStatement:
            "Chaque projet est une aventure humaine.",

        footerObjective:
            "vous rassurer par l'expertise technique et vous offrir une collaboration fluide, structurée et mutuellement enrichissante.",

        cards: [
            {
                id: "01",
                tag: "TRANSPARENCE",
                title: "Communication Claire",
                description:
                    "Élimination de l'effet tunnel. Je privilégie une communication directe pour une visibilité totale sur l'avancement, les succès et les défis."
            },
            {
                id: "02",
                tag: "PÉDAGOGIE",
                title: "Vulgarisation Technique",
                description:
                    "Traduire la complexité en langage métier pour lever les barrières à la décision. Je m'assure que chaque partie prenante comprenne les enjeux."
            },
            {
                id: "03",
                tag: "IMMERSION",
                title: "Écoute & Analyse",
                description:
                    "Avant de coder, j'écoute. Je m'immerge dans vos problématiques pour bâtir une technologie qui s'adapte à l'humain, et non l'inverse."
            },
            {
                id: "04",
                tag: "COHÉSION",
                title: "Synergie Hybride",
                description:
                    "Habitué à collaborer avec designers et coachs. Je veille à ce que l'ingénierie backend s'articule parfaitement avec l'UX et l'image."
            },
            {
                id: "05",
                tag: "HONNÊTETÉ",
                title: "Feedback Constructif",
                description:
                    "Le développement est itératif. Je propose des alternatives si une fonctionnalité compromet la stabilité ou la valeur ajoutée du projet."
            },
            {
                id: "06",
                tag: "CONFIANCE",
                title: "Business Partner",
                description:
                    "Plus qu'un prestataire. Mon implication vise à sécuriser vos actifs numériques et à vous accompagner bien au-delà de la livraison du code."
            }
        ]
    };


    const [
        activeMobileCard,
        setActiveMobileCard
    ] = useState(0);


    const mobileCarouselRef =
        useRef(null);


    /* ============================================================
       MOBILE CAROUSEL
       ============================================================ */

    const handleMobileCarouselScroll = () => {

        const carousel =
            mobileCarouselRef.current;


        if (!carousel) {
            return;
        }


        const cards =
            Array.from(
                carousel.querySelectorAll(
                    ".relationnel-mobile-carousel-card"
                )
            );


        if (!cards.length) {
            return;
        }


        const carouselRect =
            carousel.getBoundingClientRect();


        const carouselCenter =
            carouselRect.left +
            carouselRect.width / 2;


        let closestIndex = 0;
        let closestDistance = Infinity;


        cards.forEach(
            (card, index) => {

                const cardRect =
                    card.getBoundingClientRect();


                const cardCenter =
                    cardRect.left +
                    cardRect.width / 2;


                const distance =
                    Math.abs(
                        cardCenter -
                        carouselCenter
                    );


                if (
                    distance <
                    closestDistance
                ) {

                    closestDistance =
                        distance;

                    closestIndex =
                        index;
                }

            }
        );


        setActiveMobileCard(
            closestIndex
        );
    };


    return (

        <section className="relationnel-impact-section">

            <div className="relationnel-impact-container">


                {/* =================================================
                    HEADER
                    ================================================= */}

                <header className="relationnel-impact-header">


                    <h2 className="relationnel-impact-main-title">

                        <span className="relationnel-impact-title-solid">
                            {
                                contentData.titleLine1
                            }
                        </span>


                        <span className="relationnel-impact-title-stroke">
                            {
                                contentData.titleLine2
                            }
                        </span>

                    </h2>


                    <div className="relationnel-impact-intro-wrapper">

                        <div className="relationnel-impact-intro-bar" />


                        <p className="relationnel-impact-intro-text">
                            {
                                contentData.introText
                            }
                        </p>

                    </div>

                </header>


                {/* =================================================
                    DESKTOP LIST
                    ================================================= */}

                <div className="relationnel-impact-grid relationnel-desktop-grid">

                    {
                        contentData.cards.map(
                            (card) => (

                                <div
                                    key={
                                        card.id
                                    }
                                    className="relationnel-impact-card"
                                >

                                    <div className="relationnel-impact-card-top">

                                        <span className="relationnel-impact-card-id">
                                            {
                                                card.id
                                            }
                                        </span>


                                        <span className="relationnel-impact-card-tag">
                                            {
                                                card.tag
                                            }
                                        </span>

                                    </div>


                                    <div className="relationnel-impact-card-content">

                                        <h3 className="relationnel-impact-card-title">
                                            {
                                                card.title
                                            }
                                        </h3>


                                        <p className="relationnel-impact-card-desc">
                                            {
                                                card.description
                                            }
                                        </p>

                                    </div>

                                </div>

                            )
                        )
                    }

                </div>


                {/* =================================================
                    MOBILE CAROUSEL
                    ================================================= */}

                <div className="relationnel-mobile-carousel-shell">

                    <div
                        ref={
                            mobileCarouselRef
                        }
                        className="relationnel-mobile-carousel-track"
                        onScroll={
                            handleMobileCarouselScroll
                        }
                        role="region"
                        aria-roledescription="carrousel"
                        aria-label="Compétences relationnelles"
                    >

                        {
                            contentData.cards.map(
                                (
                                    card,
                                    index
                                ) => (

                                    <article
                                        key={
                                            card.id
                                        }
                                        className={`
                                            relationnel-mobile-carousel-card
                                            ${
                                                activeMobileCard === index
                                                    ? "is-active"
                                                    : ""
                                            }
                                        `}
                                    >

                                        <header className="relationnel-mobile-card-header">

                                            <span className="relationnel-mobile-card-id">
                                                {
                                                    card.id
                                                }
                                            </span>


                                            <span className="relationnel-mobile-card-tag">
                                                {
                                                    card.tag
                                                }
                                            </span>

                                        </header>


                                        <div className="relationnel-mobile-card-content">

                                            <span className="relationnel-mobile-card-kicker">
                                                RELATIONNEL / {
                                                    card.id
                                                }
                                            </span>


                                            <h3 className="relationnel-mobile-card-title">
                                                {
                                                    card.title
                                                }
                                            </h3>


                                            <div className="relationnel-mobile-card-divider" />


                                            <p className="relationnel-mobile-card-description">
                                                {
                                                    card.description
                                                }
                                            </p>

                                        </div>


                                        <footer className="relationnel-mobile-card-footer">

                                            <span>
                                                HUMAN_SYSTEM
                                            </span>


                                            <span>
                                                {
                                                    card.tag
                                                }
                                            </span>

                                        </footer>

                                    </article>

                                )
                            )
                        }

                    </div>

                </div>


                {/* =================================================
                    FINAL MANIFESTO
                    ================================================= */}

                <footer className="relationnel-impact-footer">

                    <div className="relationnel-impact-footer-content">

                        <p className="relationnel-impact-footer-manifesto">

                            <span className="relationnel-impact-footer-statement">
                                {
                                    contentData.footerStatement
                                }
                            </span>


                            <br className="relationnel-impact-footer-break" />


                            <span className="relationnel-impact-footer-objective">

                                <strong className="relationnel-impact-footer-objective-label">
                                    MON OBJECTIF :
                                </strong>

                                {" "}

                                <span className="relationnel-impact-footer-objective-text">
                                    {
                                        contentData.footerObjective
                                    }
                                </span>

                            </span>

                        </p>

                    </div>

                </footer>


            </div>

        </section>

    );
};


export default Relationnel;